export var BOX_SHADOW;
(function (BOX_SHADOW) {
    BOX_SHADOW["NORMAL"] = "0 0 8px #dfdfdf";
    BOX_SHADOW["EMPHASIZED"] = "0 0 12px #d3d3d3";
    BOX_SHADOW["INVERTED"] = "0 0 8px #767676";
})(BOX_SHADOW || (BOX_SHADOW = {}));
export var Z_INDEX;
(function (Z_INDEX) {
    Z_INDEX[Z_INDEX["NORMAL"] = 1] = "NORMAL";
    Z_INDEX[Z_INDEX["ELEVATED"] = 2] = "ELEVATED";
    Z_INDEX[Z_INDEX["DIALOG"] = 3] = "DIALOG";
    Z_INDEX[Z_INDEX["MODAL"] = 4] = "MODAL";
})(Z_INDEX || (Z_INDEX = {}));
